import React from "react";
import { useRenderOn } from "src/hooks";
import styled from "styled-components";

import { translate } from "../../../../../../../services/translation.service";
import { media } from "../../../../../../../theme";
import LinksList from "../LinksList";
import SectionFooter from "../SectionFooter";

import ContactInfo from "./components/ContactInfo";
import { helpLinksDictionary } from "./helpLinksDictionary";

const StyledLinksList = styled(LinksList)`
  margin-top: 20px;

  ${media.laptop} {
    margin: 0;
  }
`;

const HelpSection = (): JSX.Element => {
  const { mdOrDown } = useRenderOn();

  return (
    <SectionFooter title={translate("footer.needHelp")}>
      {mdOrDown ? (
        <>
          <StyledLinksList linksList={helpLinksDictionary} />
          <ContactInfo />
        </>
      ) : (
        <>
          <ContactInfo />
          <StyledLinksList linksList={helpLinksDictionary} />
        </>
      )}
    </SectionFooter>
  );
};

export default HelpSection;
